import PropTypes from 'prop-types';
import { ItemsPerPage as IPPFromCodex } from '@codex/basics';
import styled, { css } from 'styled-components';


const StyledIPPFromCodex = styled(IPPFromCodex)`
   ${({ theme }) => css`
    @media ${theme.breakpoints.touch} {
      div, span {
        font-size: 14px;
      }
    }
  `};
`;

export default function ItemsPerPage({ activeOption, itemsCount, options, isPageLoading, showLabelStart,
  showLabelEnd, showLabelEndMobile, onOptionSelected }) {

  return isPageLoading
    ? <div>Loading...</div>
    : (
      <StyledIPPFromCodex
        activeOption={activeOption}
        itemsCount={itemsCount}
        options={options}
        showLabelStart={showLabelStart}
        showLabelEnd={showLabelEnd}
        showLabelEndMobile={showLabelEndMobile}
        onOptionSelected={onOptionSelected}
      />
    );
}

ItemsPerPage.propTypes = {
  itemsCount: PropTypes.number.isRequired,
  options: PropTypes.arrayOf(PropTypes.number).isRequired,
  activeOption: PropTypes.number.isRequired,
  isPageLoading: PropTypes.bool.isRequired,
  showLabelStart: PropTypes.string.isRequired,
  showLabelEnd: PropTypes.string.isRequired,
  showLabelEndMobile: PropTypes.string.isRequired,
  onOptionSelected: PropTypes.func
};

ItemsPerPage.defaultProps = {
  onOptionSelected: () => {}
};
